import SetupMFAWebAuthn from './SetupMFAWebAuthn'

export default SetupMFAWebAuthn
